const state = {
    list: [],
    appInfo: {},
    current: {},
    rolesList: {},
    loading: true,
}

export default state
